import { render } from "./ConnectedTaConsultants.vue?vue&type=template&id=54071be3"
import script from "./ConnectedTaConsultants.vue?vue&type=script&lang=js"
export * from "./ConnectedTaConsultants.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__